import { SVGProps } from 'react'

const MandateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={45}
    height={28}
    viewBox="0 0 45 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="path-1-outside-1_9043_3859"
      maskUnits="userSpaceOnUse"
      x={0.383301}
      y={1}
      width={44}
      height={27}
      fill="black"
    >
      <rect fill="white" x={0.383301} y={1} width={44} height={27} />
      <path d="M0.383301 1H44.3833V27H0.383301V1Z" />
    </mask>
    <path
      d="M44.3833 26H0.383301V28H44.3833V26Z"
      fill="black"
      mask="url(#path-1-outside-1_9043_3859)"
    />
    <mask id="path-3-inside-2_9043_3859" fill="white">
      <path d="M24.3833 10C24.3833 4.47715 28.8605 0 34.3833 0C39.9061 0 44.3833 4.47715 44.3833 10V27H24.3833V10Z" />
    </mask>
    <path
      d="M24.3833 10C24.3833 4.47715 28.8605 0 34.3833 0C39.9061 0 44.3833 4.47715 44.3833 10V27H24.3833V10Z"
      fill="#E5E5E5"
    />
    <path
      d="M24.3833 0H44.3833H24.3833ZM44.3833 27H24.3833H44.3833ZM24.3833 27V0V27ZM34.3833 0C40.4584 0 45.3833 4.92487 45.3833 11V27H43.3833V10C43.3833 4.47715 39.3539 0 34.3833 0Z"
      fill="white"
      mask="url(#path-3-inside-2_9043_3859)"
    />
    <path
      d="M36.7834 19.8334C36.2221 17.8372 35.6418 15.7731 34.8862 13.975C33.8933 11.6124 32.6867 9.98094 31.1134 8.88449V22.834H29.7864L29.7864 7.51291L30.6212 7L30.7539 7.06703C33.0744 8.23949 34.7785 10.2688 36.1167 13.4534C36.9119 15.3458 37.499 17.4431 38.0667 19.4718C38.2985 20.2989 38.98 22.6123 38.98 22.6123L37.7063 23C37.7063 22.9998 37.0171 20.6653 36.7834 19.8336L36.7834 19.8334Z"
      fill="black"
    />
    <mask id="path-6-inside-3_9043_3859" fill="white">
      <path d="M12.3833 10C12.3833 4.47715 16.8605 0 22.3833 0C27.9061 0 32.3833 4.47715 32.3833 10V27H12.3833V10Z" />
    </mask>
    <path
      d="M12.3833 10C12.3833 4.47715 16.8605 0 22.3833 0C27.9061 0 32.3833 4.47715 32.3833 10V27H12.3833V10Z"
      fill="#E5E5E5"
    />
    <path
      d="M12.3833 0H32.3833H12.3833ZM32.3833 27H12.3833H32.3833ZM12.3833 27V0V27ZM22.3833 0C28.4584 0 33.3833 4.92487 33.3833 11V27H31.3833V10C31.3833 4.47715 27.3539 0 22.3833 0Z"
      fill="white"
      mask="url(#path-6-inside-3_9043_3859)"
    />
    <path
      d="M26.5388 7.55907L25.3224 7L22.3833 13.3969L19.4441 7L18.2278 7.55907L21.6466 15L18.2278 22.4411L19.4441 23L22.3833 16.6033L25.3224 23L26.5388 22.4411L23.12 15L26.5388 7.55907Z"
      fill="black"
    />
    <mask id="path-9-inside-4_9043_3859" fill="white">
      <path d="M0.383301 10C0.383301 4.47715 4.86045 0 10.3833 0C15.9061 0 20.3833 4.47715 20.3833 10V27H0.383301V10Z" />
    </mask>
    <path
      d="M0.383301 10C0.383301 4.47715 4.86045 0 10.3833 0C15.9061 0 20.3833 4.47715 20.3833 10V27H0.383301V10Z"
      fill="#E5E5E5"
    />
    <path
      d="M0.383301 0H20.3833H0.383301ZM20.3833 27H0.383301H20.3833ZM0.383301 27V0V27ZM10.3833 0C16.4584 0 21.3833 4.92487 21.3833 11V27H19.3833V10C19.3833 4.47715 15.3539 0 10.3833 0Z"
      fill="white"
      mask="url(#path-9-inside-4_9043_3859)"
    />
    <path
      d="M14.8391 8.01698C15.1026 7.84335 15.1704 7.49613 14.9908 7.2427C14.8092 6.9893 14.45 6.92342 14.1846 7.097L6.83278 11.9363V7.58592C6.83278 7.2786 6.57332 7.02915 6.25404 7.02915C5.93475 7.02915 5.67529 7.2786 5.67529 7.58592V12.996V12.998V22.4432C5.67529 22.7505 5.93475 23 6.25404 23C6.57332 23 6.83278 22.7505 6.83278 22.4432V17.3804L14.8411 12.0581C15.1046 11.8825 15.1704 11.5352 14.9888 11.2818C14.8072 11.0284 14.446 10.9645 14.1826 11.1401L6.83276 16.0254V13.2874L14.8391 8.01698Z"
      fill="black"
    />
  </svg>
)

export default MandateIcon
